// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorPage_errorContainer__2wfVS","errorDetails":"ErrorPage_errorDetails__24xkS","errorPageRetryBtn":"ErrorPage_errorPageRetryBtn__2kV4X"};